module.exports = __webpack_public_path__ + "static/media/down-arrow.62b1f028.svg";